var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLinkedinIcon = function SvgLinkedinIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.714 0H1.282C.575 0 0 .583 0 1.298v15.404C0 17.417.575 18 1.282 18h15.432c.707 0 1.286-.583 1.286-1.298V1.298C18 .583 17.421 0 16.714 0ZM5.44 15.429H2.772v-8.59h2.672v8.59H5.44ZM4.106 5.665a1.548 1.548 0 0 1 0-3.094 1.55 1.55 0 0 1 1.547 1.547c0 .856-.691 1.547-1.547 1.547Zm11.335 9.764h-2.668V11.25c0-.996-.02-2.278-1.386-2.278-1.39 0-1.604 1.085-1.604 2.206v4.25H7.116v-8.59h2.559v1.174h.036c.358-.675 1.23-1.387 2.527-1.387 2.7 0 3.203 1.78 3.203 4.095v4.709Z",
    fill: "currentColor"
  })));
};
export default SvgLinkedinIcon;